import { render, staticRenderFns } from "./GetStart.vue?vue&type=template&id=61844ffe&"
import script from "./GetStart.vue?vue&type=script&lang=js&"
export * from "./GetStart.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports